import { render, staticRenderFns } from "./NuevaVenta.vue?vue&type=template&id=5a07ec22&"
import script from "./NuevaVenta.vue?vue&type=script&lang=js&"
export * from "./NuevaVenta.vue?vue&type=script&lang=js&"
import style0 from "./NuevaVenta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports